<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
			<el-button type="primary" size="mini" @click="openModel('cpglbom')" icon="el-icon-plus">添加</el-button>
			<el-dropdown class="ml-2 mr-2">
				<el-button type="success" icon="el-icon-s-promotion" size="mini">审核</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item><div style="color: #7c7eff;font-size: 12px;" @click="states(1, multipleSelection)">同意</div></el-dropdown-item>
					<el-dropdown-item><div style="color: #d00003;font-size: 12px;" @click="states(2, multipleSelection)">拒绝</div></el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div>
			<el-table :data="cpglbomList" style="width: 100%" size="mini" @selection-change="handleSelectionChange" :max-height="maxHeight">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column width="180">
					<template slot="header" slot-scope="scope">产品名称</template>
					<template slot-scope="scope">{{scope.row.cpmc}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">产品编码</template>
					<template slot-scope="scope">{{scope.row.cpbm}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">规格名称</template>
					<template slot-scope="scope">{{scope.row.cpgg.name}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">规格编码</template>
					<template slot-scope="scope">{{scope.row.cpgg.ggbm}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">审核状态</template>
					<template slot-scope="scope">
						<el-button type="info" size="mini" plain v-if="scope.row.bomshzt == 0">待审核</el-button>
						<el-button type="success" size="mini" plain v-else-if="scope.row.bomshzt == 1">可用</el-button>
						<el-button type="danger" size="mini" plain v-else>不通过</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" fixed="right" width="200">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<!-- <el-button type="primary" size="mini" @click="openModel('cpglbom',scope.row)">查看</el-button> -->
						<el-button type="primary" size="mini" @click="openModel('cpglbom',scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl ==='cpglbom' " ref="form" :model="form.cpglbom" label-width="80px">
					<el-form-item label="* 名称">
						<el-input v-model="form.cpglbom.mc" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="负责人">
						<el-select v-model="form.cpglbom.zz" filterable placeholder="请选择" size="mini">
						    <el-option
						      v-for="item in userlist"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
					</el-form-item>
					<el-form-item label="人员组">
						<el-select v-model="ryzs" multiple placeholder="请选择" size="mini">
						    <el-option
						      v-for="item in userlist"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
					</el-form-item>
				</el-form>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				cpglbom: {
				},
			},
			userlist:[],
			ryzs:[],
			createModel: false,
			dialogType: "cpglbom",
			preUrl: "cpglbom", //api
			dialogId: 0,
			cpglbomList:[],
			multipleSelection: [],
			maxHeight: 0,
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 处理列表结果
		getListResult(e) {
			this.cpglbomList = e.list
			this.axios.get('/admin/managers/list',{
				token: true
			}).then(res => {
				this.userlist = res.data.data
			})
		},
		states(e, f) {
			if (f.length == 0) {
				return this.$message({
					type: 'error',
					message: '请选择要操作的订单'
				});
			}else{
				let x = f.map(i => {
					return i.id;
				});
				let i = {
					shzt: e,
					ids: x
				};
				this.axios.post('/admin/cpboms/ids', i,{
					token: true
				}).then(res => {
					this.getList()
				})
			}
			
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'cpglbom':
					if (!item) {
						this.form.cpglbom = {
							id:'',
							mc: "",
							zz: ""
						}
						this.dialogId = 0
					} else {
						this.form.cpglbom = {
							mc: item.mc,
							zz: item.zz.id,
							id:item.id
						}
						this.ryzs = item.ryz.map(i=>{
							return i.ry
						})
						this.dialogId = item.id
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.cpglbom
			let e = {
				mc: f.mc,
				zz: f.zz,
				cjr:this.user.id
			}
			let ds = {
				ids:this.ryzs,
				lists:e
			}
			let url = !this.form.cpglbom.id == true ? '/admin/cpglbom' : '/admin/cpglbom/' + this.form.cpglbom.id
			this.axios.post(url, ds, {
				token: true
			}).then(res => {
				console.log(res.data)
				this.$message({
					type: "success",
					message: !this.form.cpglbom.id == true ? "下单成功" : "修改成功"
				})
				this.getList()
				this.createModel = false;
			})
			
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
